var colors = { brt:64, con:0, hue:0, sat:128, fill: 0, cast: 0, cast_color: new RGB(0xFF, 0xE1, 0x00) };

//

	var tab_lup = [ 0,2,2,5,5,8,7,10,10,12,15,15,18,18,21,23,23,26,28,29,29,31,32,32,34,37,38,40,40,41,44,45,46,46,48,49,52,53,55,57,57,59,60,63,64,65,67,68,71,73,
	74,76,77,79,81,83,85,87,88,89,91,93,95,96,98,100,101,103,105,106,110,111,114,116,116,119,120,122,123,127,128,130,132,133,135,138,139,141,143,144,146,148,150,152,153,154,157,159,161,162,
	164,166,168,170,170,174,174,175,178,178,182,182,183,185,187,189,190,192,193,195,195,197,200,200,202,203,204,206,206,208,210,211,212,213,214,215,215,217,219,220,220,221,223,223,225,226,226,227,228,228,
	229,230,231,231,232,234,234,234,235,235,236,237,237,238,239,239,240,241,241,241,242,243,243,244,243,244,245,245,246,245,246,247,247,246,247,248,248,247,249,249,249,249,249,250,250,250,250,249,251,251,
	250,251,251,251,252,252,252,252,252,252,252,253,253,253,252,253,252,253,253,253,253,253,254,254,254,254,253,254,253,254,254,254,254,254,254,254,254,254,254,254,254,255,255,255,255,255,255,255,255,255,
	255,255,255,255,255,255];
	var tab_ldown = [ 0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
	0,0,0,1,2,1,1,1,1,1,1,1,2,3,2,3,3,3,2,4,4,4,3,4,5,5,5,6,6,7,8,7,7,8,8,9,10,9,11,11,11,12,14,13,14,15,16,16,18,18,
	20,21,21,23,25,26,26,26,28,27,30,29,31,31,32,32,34,33,36,36,37,38,39,39,40,41,43,44,45,46,48,49,50,51,53,54,55,56,58,59,60,61,64,65,66,67,70,71,73,73,
	76,77,79,80,82,85,86,87,89,91,93,94,96,97,99,102,104,105,106,109,110,113,114,116,119,120,121,125,126,128,130,132,133,135,136,139,142,144,145,148,150,152,153,154,156,158,160,162,164,167,
	169,171,171,173,176,178,179,182,183,186,188,190,192,194,196,198,198,200,202,204,205,208,210,210,212,214,216,218,218,220,222,224,226,226,228,231,231,232,235,236,237,238,241,240,242,242,245,246,247,249,
	249,251,250,253,253,255 ];
	var color_level = new Array(256);

	function color_precalc()
	{
		var a, temp = new Array(256);
		var brt = colors.brt;
		var con = colors.con;

		if (brt < 64)
			for (a = 0; a < 256; a++)
				temp[a] = a + Math.floor( ((tab_ldown[a] - a)*(63 - brt))/63 );
		else
			for (a = 0; a < 256; a++)
				temp[a] = a + Math.floor( ((tab_lup[a] - a)*(brt-64))/63 );

		for (a = 0; a < 128; a++) color_level[a] = 0;
		for (a = 0; a < 256 - con; a++)
			color_level[con+a] = temp[Math.floor( (255*a)/(255 - con) )];
	}

	var tab_warmth_r = new Array(256);
	var tab_warmth_g = new Array(256);
	var tab_warmth_b = new Array(256);
	var col_wm = new RGB(0x7F, 0x7F, 0x7F);

	var tab_colhex = new Array(256);

	function color_precalc_colhex()
	{
		var a;

		for (a = 0; a < 256; a++)
			tab_colhex[a] = (a < 16 ? '0' : '') + a.toString(16);
	}

	function color_precalc_warmth()
	{
		var a;

		for (a = 0; a < 256; a++)
		{
			tab_warmth_r[a] = col_wm.r + Math.floor(((colors.cast_color.r - col_wm.r) * a) / 255);
			tab_warmth_g[a] = col_wm.g + Math.floor(((colors.cast_color.g - col_wm.g) * a) / 255);
			tab_warmth_b[a] = col_wm.b + Math.floor(((colors.cast_color.b - col_wm.b) * a) / 255);
		}
	}

	function color_adjust(r_in, g_in, b_in)
	{
		var r, g, b;
		var w = colors.cast;
		var l = w;
		var s = colors.sat;

		r = r_in;
		g = g_in;
		b = b_in;

		if (l > 0)
		{
			var rm, gm, bm;

			rm = Math.floor((r*tab_warmth_r[w])/255);
			gm = Math.floor((g*tab_warmth_g[w])/255);
			bm = Math.floor((b*tab_warmth_b[w])/255);

			r = r + Math.floor(((rm - r) * l) / 255);
			g = g + Math.floor(((gm - g) * l) / 255);
			b = b + Math.floor(((bm - b) * l) / 255);
		}
		if (s != 128)
		{
			if (s < 128)
			{
				var gr = ((0.299*r + 0.587*g + 0.114*b)*(128 - s))/128 ;
				r = gr + (r * s)/128;
				g = gr + (g * s)/128;
				b = gr + (b * s)/128;
			}
			else
			{
				s -= 128;
				var str;

				if (r > g && r > b)
					str = 255 / r;
				else
				if (g > r && g > b)
					str = 255 / g;
				else
					str = 255 / b;

				r = ( ((r * str) * s) + (r * (128 - s)) )/128;
				g = ( ((g * str) * s) + (g * (128 - s)) )/128;
				b = ( ((b * str) * s) + (b * (128 - s)) )/128;
				if (isNaN(r)) r = 0;
				if (isNaN(g)) g = 0;
				if (isNaN(b)) b = 0;
			}
		}

		r = Math.floor(r); g = Math.floor(g); b = Math.floor(b);
		if (r > 255) r = 255;
		if (g > 255) g = 255;
		if (b > 255) b = 255;
		r = color_level[r];
		g = color_level[g];
		b = color_level[b];

		return ('#'+tab_colhex[r]+tab_colhex[g]+tab_colhex[b]);
	}
